<s1-modal #modal [title]="'funzioneAzioneMenu.title'" (onClose)="refresh()">
    <!--<be-prenotazione-dettaglio *ngIf="loaded" [showNavigationButtons]="false" [_numeroPrenotazione]="slot?.numeroPrenotazione" (needClose)="close()"></be-prenotazione-dettaglio>-->
  <azioni-menu-ricerca [ricercaAzioniPreferiti]="true">

  </azioni-menu-ricerca>
    
  </s1-modal>
  